/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { APPS_COMPONENT_ID } from '../../utils/enums';
import LoggerUtil from '../../utils/LoggerUtil';
import { APPS_SKELETON_LAYOUTS } from '../../layouts/layoutConstants';
import { AppsPanelSkeleton } from '../../stores/skeleton';
import Apps from '../../stores/apps';
import AppConfig from '../../stores/config';
import AppLoader from '../../stores/appLoader';
import Banners from '../../stores/banners';

const COMPONENT_ID = 'AppsSkeletonComponent';

class AppsSkeleton extends Component {
    render() {
        const { layouts } = AppConfig;
        const { props } = this;
        const { skeletonLayoutID } = AppsPanelSkeleton;

        let SkeletonLayout;
        const isExternalLayout = (skeletonLayoutID
            && Object.prototype.hasOwnProperty.call(layouts.skeleton, skeletonLayoutID));

        if (isExternalLayout) {
            SkeletonLayout = layouts.skeleton[skeletonLayoutID];
        } else {
            LoggerUtil.warn(`${APPS_COMPONENT_ID}: ${COMPONENT_ID}: Skeleton layouts not found!`);
            SkeletonLayout = layouts.skeleton[APPS_SKELETON_LAYOUTS.DEFAULT];
        }
        return (
            <SkeletonLayout
                appConfig={AppConfig}
                appLoader={AppLoader}
                appsPanelSkeleton={AppsPanelSkeleton}
                apps={Apps}
                banners={Banners}
                {...props}
            />
        );
    }
}

export default observer(AppsSkeleton);
